<template>
  <section>
    <div class="customProductDetail main" v-if="isPC">
        <div class="breadcrumb" v-if="mode !== 'visitorAdd'">
            <el-breadcrumb separator="<">
                <el-breadcrumb-item class="fontfine" :to="{ path: '/commodity/customProduct/list' }">{{ $t('customDetail.Back') }}</el-breadcrumb-item>
                <el-breadcrumb-item><a >{{ modeTextObj[mode] }}</a></el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="breadcrumb" v-else>
            <el-breadcrumb separator="<">
                <el-breadcrumb-item class="fontfine" :to="{ path: '/' }">{{ $t('customDetail.Back') }}</el-breadcrumb-item>
                <el-breadcrumb-item><a >{{ $t('customDetail.AddNewDemand') }}</a></el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- style -->
        <div class="formContent bg-white" v-cloak>
          <div class="top f-b">
              <div class="title boldLabel">{{ $t('Home.Customized.AddProduct.BasicInformation') }}</div>
              <div class="icon"></div>
          </div>
          <div class="f" v-if="mode === 'read'" style="margin: 8px 0">
            <template>
              <div class="f--c" v-if="+servicesSelect === 1">
                <img src="https://img.kakaclo.com/web-img/customizeOnDemand.png" style="width:32px;height:32px;margin-right:4px">
                <p style="font-weight:500;font-family: Poppins;">{{ $t('Home.Customized.AddProduct.CustomizeOnDemand') }}</p>
              </div>
            </template>
            <template>
              <div class="f--c" v-if="+servicesSelect === 2">
                <img src="https://img.kakaclo.com/web-img/print_customize/PrintOnDemand.png" style="width:32px;height:32px;margin-right:4px">
                <p style="font-weight:500;font-family: Poppins">{{ $t('Home.Customized.AddProduct.PrintOnDemand') }}</p>
              </div>
            </template>
          </div>
          <el-form label-position="top" label-width="80px" :model="styleFormObj" :hide-required-asterisk="true" ref="styleFormObj" :rules="StyleRules">
              <el-row>
                  <el-col :span="7">
                      <el-form-item :label="$t('Home.Customized.AddProduct.ProductName')" required prop="productName">
                          <div slot="label" class="formRequiredSign">{{ $t('customDetail.ProductName') }}</div>
                          <div v-if="mode === 'read'">{{ styleFormObj.productName }}</div>
                          <el-input v-model="styleFormObj.productName" :placeholder="$t('customDetail.ProductNamePlace')" maxlength="100" show-word-limit v-else></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="1">
                      <el-form-item required prop="email">
                          <div slot="label" class="formRequiredSign">{{ $t('customDetail.ContactEmail') }}</div>
                          <div v-if="mode === 'read'">{{ styleFormObj.email }}</div>
                          <el-input v-model.trim="styleFormObj.email" :placeholder="$t('customDetail.ContactEmailPlace')" v-else></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="1">
                      <el-form-item required prop="phoneNumber">
                          <div slot="label" class="formRequiredSign">{{ $t('customDetail.PhoneNumber') }}</div>
                          <div v-if="mode === 'read'">{{ styleFormObj.phoneAreaCode }} {{ styleFormObj.phoneNumber }}</div>
                          <div class="inputSelectGroup" v-else>
                              <el-select v-model="styleFormObj.phoneAreaCode" style="width: 30%;color: #fff" filterable >
                                  <el-option v-for="(item,index) in areanolist" :label="item.code" :value="item.code" :key="index"></el-option>
                              </el-select>
                              <el-input :placeholder="$t('customDetail.PhoneNumber')" v-model="styleFormObj.phoneNumber" style="width: 70%" maxlength="20" show-word-limit @input="value=> numCheck(value, {target: styleFormObj, key: 'phoneNumber'})"></el-input>
                          </div>
                      </el-form-item>
                  </el-col>
              </el-row>
              <el-row v-if="['add', 'edit', 'visitorAdd'].includes(mode)">
                <el-col :span="22">
                  <el-form-item>
                      <div slot="label" class="boldLabel">{{ $t('Home.Customized.AddProduct.Services') }}</div>
                      <div class="f ServicesBox">
                        <template>
                          <div class="f--c pointer" :class="{serviceActive: servicesSelect === 1}" @click="servicesSelect = 1">
                            <img src="https://img.kakaclo.com/web-img/customizeOnDemand.png">
                            <p>{{ $t('Home.Customized.AddProduct.CustomizeOnDemand') }}</p>
                            <i class="el-icon-success" :class="{iconActive: servicesSelect === 1}"></i>
                          </div>
                        </template>
                        <template>
                          <!-- 暂时关闭pod定制  <div class="f--c" :class="{serviceActive: servicesSelect === 2}" @click="servicesSelect = 2"> -->
                          <div class="f--c" :class="{serviceActive: servicesSelect === 2}" style="color:#888;background-color:#eee; cursor: no-drop;">
                            <img src="https://img.kakaclo.com/web-img/print_customize/PrintOnDemand.png">
                            <p>{{ $t('Home.Customized.AddProduct.PrintOnDemand') }}</p>
                            <i class="el-icon-success" :class="{iconActive: servicesSelect === 2}"></i>
                          </div>
                        </template>
                      </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-show="servicesSelect === 2">
                <el-col :span="22">
                  <el-form-item>
                    <div slot="label" class="boldLabel">{{ ['add', 'edit', 'visitorAdd'].includes(mode)? 'Custom Printed& Embroidered Products' : 'Clothing type'}}</div>
                    <div class="f fw-w printImagesBox">
                      <div
                        v-for="item in printImageList"
                        :key="item.url"
                        style="margin: 0 40px 20px 0"
                        :style="{display: ((mode === 'read' && item.check) || ['add', 'edit', 'visitorAdd'].includes(mode)) ? 'block': 'none'}">
                        <div
                          class="pointer f-c-c imageItem"
                          :class="{imageActive: item.check && ['add', 'edit', 'visitorAdd'].includes(mode), smallSize: mode === 'read'}"
                          @click="printStyleClick(item)"
                          >
                          <el-image :src="item.url"></el-image>
                          <i class="el-icon-success" :class="{iconActive: item.check && ['add', 'edit', 'visitorAdd'].includes(mode)}"></i>
                        </div>
                        <div class="printText">{{item.text}}</div>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="servicesSelect && servicesSelect === 2">
                  <el-col :span="23">
                      <el-form-item>
                          <div slot="label">
                              <span class="formRequiredSign" style="margin-right: 10px">{{ $t('customDetail.Image')}}</span>
                              <span>{{ $t('customDetail.ImageTip')}}</span>
                          </div>
                          <div class="f fw-w">
                              <el-upload
                                  action="https://jsonplaceholder.typicode.com/posts/"
                                  list-type="picture-card"
                                  :multiple="true"
                                  :before-upload="file => imgUploadBefore(textFormObj.imageList, file, 'Style', textFormObj)"
                                  style="margin: 0 10px 10px 0"
                                  v-if="mode !== 'read'">
                                  <i class="el-icon-plus"></i>
                              </el-upload>
                              <template>
                                <div class="pictureCard" v-for="(imgUrl, index) in textFormObj.imageList" :key="imgUrl">
                                    <img :src="imgUrl" @click="imgVisit(imgUrl)">
                                    <i class="el-icon-close" @click="imgUrlDelete(textFormObj.imageList, index, textFormObj)" v-if="mode !== 'read'"></i>
                                    <div class="deleteIcon" @click="imgUrlDelete(textFormObj.imageList, index, textFormObj)" v-if="mode !== 'read'"></div>
                                </div>
                              </template>
                              <template v-if="imageLoading">
                                  <div style="width:148px;height:148px" v-loading="true" v-for="(file, index) in uploadImageList" :key="index"></div>
                              </template>
                          </div>
                      </el-form-item>
                  </el-col>
              </el-row>
              <template v-if="servicesSelect">
                <el-row>
                  <el-col :span="7">
                      <el-form-item required prop="estimatedOrderQuantity">
                          <div slot="label" class="formRequiredSign">{{ $t('customDetail.EstimatedOrderQuantity')}}</div>
                          <div v-if="mode === 'read'">{{ styleFormObj.estimatedOrderQuantity }}</div>
                          <el-input
                              v-model.number="styleFormObj.estimatedOrderQuantity"
                              :placeholder="$t('customDetail.EstimatedOrderQuantityPlace')"
                              v-else
                              @input="value=> numCheck(value, {target: styleFormObj, key: 'estimatedOrderQuantity'})"
                              @blur="e => intCheck(e, {target: styleFormObj, key: 'estimatedOrderQuantity'})"></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="1">
                      <el-form-item required prop="colorQuantity">
                          <div slot="label" class="formRequiredSign">{{ $t('customDetail.ColorQuantity')}}</div>
                          <div v-if="mode === 'read'">{{ styleFormObj.colorQuantity }}</div>
                          <el-input
                              v-model.number="styleFormObj.colorQuantity"
                              :placeholder="$t('customDetail.ColorQuantityPlace')"
                              v-else
                              @input="value=> numCheck(value, {target: styleFormObj, key: 'colorQuantity'})"
                              @blur="e => intCheck(e, {target: styleFormObj, key: 'colorQuantity'})"></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="7" :offset="1">
                      <el-form-item required prop="sizeQuantity">
                          <div slot="label" class="formRequiredSign">{{ $t('customDetail.SizeQuantity')}}</div>
                          <div v-if="mode === 'read'">{{ styleFormObj.sizeQuantity }}</div>
                          <el-input
                              v-model.number="styleFormObj.sizeQuantity"
                              :placeholder="$t('customDetail.SizeQuantityPlace')"
                              v-else
                              @input="value=> numCheck(value, {target: styleFormObj, key: 'sizeQuantity'})"
                              @blur="e => intCheck(e, {target: styleFormObj, key: 'sizeQuantity'})"></el-input>
                      </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="23">
                    <el-form-item prop="Material" label="Material">
                      <div v-if="mode === 'read'" class="readRow f fw-w">
                        <div v-for="item in styleFormObj.material.split(',')" :key="item" class="materialItem">{{item | materialHandle}}</div>
                      </div>
                      <el-select v-model="material" multiple placeholder="select" collapse-tags style="width:240px" clearable v-else>
                        <el-option v-for="item in materialSelectList" :key="item.en" :value="item.value" :label="item.en"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                    <el-col :span="23">
                        <el-form-item prop="referenceLinking">
                            <div slot="label">
                                {{ $t('customDetail.ReferenceLinking')}}
                                <el-tooltip class="item" effect="dark" :content="$t('customDetail.ReferenceLinkingTooltip')" placement="top-start">
                                    <i class="el-icon-warning-outline"></i>
                                </el-tooltip>
                            </div>
                            <div v-if="mode === 'read'">{{ textFormObj.referenceLinking }}</div>
                            <el-input v-model="textFormObj.referenceLinking" :placeholder="$t('customDetail.ReferenceLinkingPlace')" maxlength="10000" show-word-limit v-else></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="23">
                        <el-form-item prop="description">
                            <div slot="label">
                                {{ $t('customDetail.Description')}}
                            </div>
                            <div v-if="mode === 'read'">{{ textFormObj.description }}</div>
                            <el-input v-model="textFormObj.description" :placeholder="$t('customDetail.DescriptionPlace')" maxlength="5000" show-word-limit type="textarea" resize="none" :rows="4" v-else></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="servicesSelect && servicesSelect !== 2">
                    <el-col :span="23">
                        <el-form-item>
                            <div slot="label">
                                <span class="formRequiredSign" style="margin-right: 10px">{{ $t('customDetail.Image')}}</span>
                                <span>{{ $t('customDetail.ImageTip')}}</span>
                            </div>
                            <div class="f fw-w">
                                <el-upload
                                    action="https://jsonplaceholder.typicode.com/posts/"
                                    list-type="picture-card"
                                    :multiple="true"
                                    :before-upload="file => imgUploadBefore(textFormObj.imageList, file, 'Style', textFormObj)"
                                    style="margin: 0 10px 10px 0"
                                    v-if="mode !== 'read'">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                                <template>
                                  <div class="pictureCard" v-for="(imgUrl, index) in textFormObj.imageList" :key="imgUrl">
                                      <img :src="imgUrl" @click="imgVisit(imgUrl)">
                                      <i class="el-icon-close" @click="imgUrlDelete(textFormObj.imageList, index, textFormObj)" v-if="mode !== 'read'"></i>
                                      <div class="deleteIcon" @click="imgUrlDelete(textFormObj.imageList, index, textFormObj)" v-if="mode !== 'read'"></div>
                                  </div>
                                </template>
                                <template v-if="imageLoading">
                                    <div style="width:148px;height:148px" v-loading="true" v-for="(file, index) in uploadImageList" :key="index"></div>
                                </template>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
              </template>
          </el-form>
        </div>
    </div>
    <div class="customProductDetailForMobile" v-else>
      <div class="breadcrumb bg-white" @click="$router.go(-1)">
          <i class="el-icon-arrow-left"></i>
          <span>{{ $t('customDetail.AddNewDemand') }}</span>
      </div>
      <el-form label-position="top" label-width="80px" :model="styleFormObj" :hide-required-asterisk="true" ref="styleFormObj" :rules="StyleRules">
        <div class="formContentForMobile bg-white">
          <el-form-item required prop="productName">
            <div v-if="mode === 'read'">{{ styleFormObj.productName }}</div>
            <el-input v-model="styleFormObj.productName" :placeholder="$t('customDetail.ProductName')" maxlength="100" show-word-limit v-else class="mobileInput requiredInputMobile"></el-input>
          </el-form-item>
          <el-form-item required prop="email">
            <div v-if="mode === 'read'">{{ styleFormObj.email }}</div>
            <el-input v-model="styleFormObj.email" :placeholder="$t('customDetail.ContactEmail')" v-else class="mobileInput requiredInputMobile"></el-input>
          </el-form-item>
          <el-form-item required prop="phoneNumber">
            <div v-if="mode === 'read'">{{ styleFormObj.phoneAreaCode }} {{ styleFormObj.phoneNumber }}</div>
            <div class="inputSelectGroup" v-else>
                <el-select v-model="styleFormObj.phoneAreaCode" style="width: 30%;color: #fff" filterable class="mobileInput">
                    <el-option v-for="(item,index) in areanolist" :label="item.code" :value="item.code" :key="index"></el-option>
                </el-select>
                <el-input
                  :placeholder="$t('customDetail.PhoneNumber')"
                  v-model="styleFormObj.phoneNumber"
                  style="width: 70%"
                  maxlength="20"
                  show-word-limit
                  @input="value=> numCheck(value, {target: styleFormObj, key: 'phoneNumber'})"
                  class="mobileInput requiredInputMobile"></el-input>
            </div>
          </el-form-item>
        </div>
        <div class="formContentForMobile bg-white" style="padding:14px">
          <el-form-item>
            <div slot="label" class="mtOutLabel mtOutLabelRed">{{ $t('Home.Customized.AddProduct.Services') }}</div>
            <div
            class="serviceBoxMT f--c p-r"
            @click="servicesSelect = 1"
            :class="{serviceActiveMt: +servicesSelect === 1}"
            v-if="['add', 'edit', 'visitorAdd'].includes(mode) || +servicesSelect === 1">
              <img src="https://img.kakaclo.com/web-img/customizeOnDemand.png">
              <p>{{ $t('Home.Customized.AddProduct.CustomizeOnDemand') }}</p>
              <i class="el-icon-success" :class="{iconActive: servicesSelect === 1}" v-if="mode !== 'read'"></i>
            </div>
            <!-- <div
            class="serviceBoxMT f--c p-r"
            @click="servicesSelect = 2"
            :class="{serviceActiveMt: +servicesSelect === 2}"
            v-if="['add', 'edit', 'visitorAdd'].includes(mode) || +servicesSelect === 2"> -->
            <div
            style="color:#888;background-color:#eee;"
            class="serviceBoxMT f--c p-r"
            :class="{serviceActiveMt: +servicesSelect === 2}"
            v-if="['add', 'edit', 'visitorAdd'].includes(mode) || +servicesSelect === 2">
              <img src="https://img.kakaclo.com/web-img/print_customize/PrintOnDemand.png">
              <p>{{ $t('Home.Customized.AddProduct.PrintOnDemand') }}</p>
              <i class="el-icon-success" :class="{iconActive: servicesSelect === 2}" v-if="mode !== 'read'"></i>
            </div>
          </el-form-item>
        </div>
        <div class="formContentForMobile bg-white" style="padding:14px" v-show="+servicesSelect === 2">
          <el-form-item>
            <div slot="label" class="mtOutLabel">{{ $t('Home.Customized.AddProduct.CustomPrintedEmbroideredProducts') }}</div>
              <div class="f-b printImageBoxMt">
                <div v-for="item in printImageList.slice(0, 4)" :key="item.url" :style="{borderColor: item.check ? '#99C41C' : '#CDD4DD'}" @click="printStyleClick(item)" class="imageBox">
                  <oss-img :src="item.url" :width="32" :height="32"></oss-img>
                </div>
              </div>
              <div class="f-b printImageBoxMt">
                <div v-for="item in printImageList.slice(4)" :key="item.url" :style="{borderColor: item.check ? '#99C41C' : '#CDD4DD'}" @click="printStyleClick(item)" class="imageBox">
                  <oss-img :src="item.url" :width="32" :height="32"></oss-img>
                </div>
              </div>
          </el-form-item>
        </div>
        <template v-if="servicesSelect">
          <div class=" bg-white  formContentForMobile" style="padding: 14px">
            <div class="mtOutLabel">{{ $t('Home.Customized.AddProduct.Image') }}</div>
            <div class="imageListBox f fw-w">
              <el-upload
                  action="https://jsonplaceholder.typicode.com/posts/"
                  list-type="picture-card"
                  :multiple="true"
                  :before-upload="file => imgUploadBefore(textFormObj.imageList, file, 'Style', textFormObj)"
                  class="uploadBox"
                  v-if="mode !== 'read'">
                  <i class="el-icon-plus"></i>
              </el-upload>
              <template v-if="imageLoading">
                  <div style="width:90px;height:90px" v-loading="true" v-for="(file, index) in uploadImageList" :key="index"></div>
              </template>
              <template v-else>
                <div class="pictureCard" v-for="(imgUrl, index) in textFormObj.imageList" :key="imgUrl">
                    <img :src="imgUrl" @click="imgVisit(imgUrl)">
                    <i class="el-icon-close" @click="imgUrlDelete(textFormObj.imageList, index, textFormObj)" v-if="mode !== 'read'"></i>
                    <div class="deleteIcon" @click="imgUrlDelete(textFormObj.imageList, index, textFormObj)" v-if="mode !== 'read'"></div>
                </div>
              </template>
            </div>
          </div>
          <div class="formContentForMobile bg-white">
            <el-form-item required prop="estimatedOrderQuantity">
              <div v-if="mode === 'read'">{{ styleFormObj.estimatedOrderQuantity }}</div>
              <el-input
                v-model.number="styleFormObj.estimatedOrderQuantity"
                :placeholder="$t('customDetail.EstimatedOrderQuantity')"
                v-else
                @input="value=> numCheck(value, {target: styleFormObj, key: 'estimatedOrderQuantity'})"
                @blur="e => intCheck(e, {target: styleFormObj, key: 'estimatedOrderQuantity'})"
                class="mobileInput requiredInputMobile"></el-input>
            </el-form-item>
            <el-form-item required prop="colorQuantity">
              <div v-if="mode === 'read'">{{ styleFormObj.colorQuantity }}</div>
              <el-input
                v-model.number="styleFormObj.colorQuantity"
                :placeholder="$t('customDetail.ColorQuantity')"
                v-else
                @input="value=> numCheck(value, {target: styleFormObj, key: 'colorQuantity'})"
                @blur="e => intCheck(e, {target: styleFormObj, key: 'colorQuantity'})"
                class="mobileInput requiredInputMobile"></el-input>
            </el-form-item>
            <el-form-item required prop="sizeQuantity">
              <div v-if="mode === 'read'">{{ styleFormObj.sizeQuantity }}</div>
              <el-input
                v-model.number="styleFormObj.sizeQuantity"
                :placeholder="$t('customDetail.SizeQuantity')"
                v-else
                @input="value=> numCheck(value, {target: styleFormObj, key: 'sizeQuantity'})"
                @blur="e => intCheck(e, {target: styleFormObj, key: 'sizeQuantity'})"
                class="mobileInput requiredInputMobile"></el-input>
            </el-form-item>
          </div>
          <div class="formContentForMobile bg-white">
            <el-form-item prop="Material">
              <el-select v-model="material" multiple placeholder="Material" collapse-tags clearable class="materialMt">
                <el-option v-for="item in materialSelectList" :key="item.en" :value="item.value" :label="item.en"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="formContentForMobile bg-white">
            <el-form-item prop="referenceLinking">
              <div v-if="mode === 'read'">{{ textFormObj.referenceLinking }}</div>
              <el-input v-model="textFormObj.referenceLinking" :placeholder="$t('customDetail.ReferenceLinking')" maxlength="10000" show-word-limit v-else class="mobileInput"></el-input>
            </el-form-item>
          </div>
          <div class="formContentForMobile bg-white">
            <el-form-item prop="description">
              <div v-if="mode === 'read'">{{ textFormObj.description }}</div>
              <el-input v-model="textFormObj.description" :placeholder="$t('customDetail.Description')" maxlength="5000" show-word-limit type="textarea" resize="none" :rows="4" v-else class="mobileInput"></el-input>
            </el-form-item>
          </div>
        </template>
      </el-form>
    </div>
    <div class="bottomButton f-a-c" v-if="mode !== 'read'">
        <el-button type="primary" style="width: 300px;height: 40px" @click="submit">{{ $t('customDetail.Submit') }}</el-button>
    </div>
    <el-dialog :visible.sync="dialogVisible" :width="isPC? '1200px' : '90%'">
        <img width="100%" :src="dialogImageUrl">
    </el-dialog>
  </section>
</template>

<script>
import API from '@/api'
import areanolist from '@/config/areanolist.js'
import { checkEmail } from '@/util/validate'
import dayjs from 'dayjs'
import { materialList } from '@/config/material.js'
import _ from 'lodash'
import ImageCompressor from 'js-image-compressor'

export default {
  data() {
    let valiEmailPss = (rule, value, callback) => {
      if (checkEmail(value)) {
        callback()
      } else {
        callback(new Error('Please enter your vaild email'))
      }
    }
    let valiNumberPass = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error('Must be greater than zero'))
      }
      callback()
    }
    return {
      styleFormObj: {
        productName: undefined,
        email: undefined,
        estimatedOrderQuantity: undefined,
        colorQuantity: undefined,
        sizeQuantity: undefined,
        referenceLinking: undefined,
        description: undefined,
        phoneNumber: undefined,
        phoneAreaCode: '+1',
        imageUrl: '',
        imageList: [],
        material: '',
        podStyle: ''
      },
      StyleRules: {
        productName: [{ required: true, message: 'Please enter your products name' }, { trigger: ['blur'] }],
        email: [{ required: true, message: 'Please enter your email' }, { validator: valiEmailPss, trigger: ['blur'] }],
        estimatedOrderQuantity: [{ required: true, message: 'Please enter your estimated order quantity' }, { type: 'number', trigger: ['blur'], validator: valiNumberPass }],
        colorQuantity: [{ required: true, message: 'Please enter your color quantity' }, { type: 'number', trigger: ['blur'], validator: valiNumberPass }],
        sizeQuantity: [{ required: true, message: 'Please enter your size quantity' }, { type: 'number', trigger: ['blur'], validator: valiNumberPass }],
        phoneNumber: [{ required: true, message: 'Please enter your phone number' }, { trigger: ['blur'] }]
      },
      styleFormImageList: [],
      imageSignValue: '', // 图片上传唯一凭证
      dialogImageUrl: '',
      dialogVisible: false,
      areanolist,
      mode: 'add',
      textFormObj: {
        description: undefined,
        imageUrl: undefined,
        otherTechnologyDescription: undefined,
        otherTechnologyName: undefined,
        referenceLinking: undefined,
        washingDescription: undefined,
        washingPosition: undefined,
        washingType: undefined,
        imageList: []
      },
      uploadImageTimer: null,
      uploadImageList: [],
      pathUrl: '',
      materialSelectList: _.sortBy(materialList, e => e.en),
      material: [],
      imageLoading: false,
      servicesSelect: undefined, // 1 Customize on Demand   2 Print on Demand
      printSelect: [],
      printImageList: [
        { url: 'https://img.kakaclo.com/web-img/print_customize/T-shirt.png',
          value: 1,
          check: false,
          text: 'T-shirt'
        },
        { url: 'https://img.kakaclo.com/web-img/print_customize/Hoodie.png',
          value: 2,
          check: false,
          text: 'Hoodie'
        },
        { url: 'https://img.kakaclo.com/web-img/print_customize/Long%20Sleeve%20T-Shirt.png',
          value: 3,
          check: false,
          text: 'Long Sleeve T-Shirt'
        },
        { url: 'https://img.kakaclo.com/web-img/print_customize/Slim%20Fit%20T-shirt.png',
          value: 4,
          check: false,
          text: 'Slim Fit T-shirt'
        },
        { url: 'https://img.kakaclo.com/web-img/print_customize/Shirt.png',
          value: 5,
          check: false,
          text: 'Shirt'
        },
        { url: 'https://img.kakaclo.com/web-img/print_customize/Polo%20Shirts.png',
          value: 6,
          check: false,
          text: 'Polo Shirts'
        },
        { url: 'https://img.kakaclo.com/web-img/print_customize/Pants.png',
          value: 7,
          check: false,
          text: 'Pants'
        },
        { url: 'https://img.kakaclo.com/web-img/print_customize/Shorts.png',
          value: 8,
          check: false,
          text: 'Shorts'
        }
      ]
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.pathUrl = from.fullPath
    })
  },
  computed: {
    modeTextObj() {
      const obj = {
        add: this.$t('customDetail.AddNewDemand'),
        edit: this.$t('customDetail.edit'),
        read: this.$t('customDetail.detail')
      }
      return obj
    }
  },
  filters: {
    materialHandle(value) {
      let target = materialList.find(e => +e.value === +value) || { en: '' }
      return target.en
    }
  },
  async mounted() {
    this.decisionMode()
    let imageSignValue = await API.customProductGetSignValue({ directory: 'customProduct/' })
    this.imageSignValue = imageSignValue.data
    if (this.pathUrl === '/mall/similar' && sessionStorage.getItem('similar_img') !== null) {
      this.textFormObj.imageList = [sessionStorage.getItem('similar_img')]
      this.textFormObj.imageUrl = this.textFormObj.imageList.toString()
    }
  },
  methods: {
    imgUploadBefore(arr, file, which, form) {
      if ((file.size / 1024 / 1024) > 5) {
        this.$message.error(this.$t('customDetail.pictureSize'))
        return false
      }
      if (['image/png', 'image/jpeg', 'image/webp'].includes(file.type)) {
        let maxlength = ['Style'].includes(which) ? 10 : 1
        if ((arr.length + this.uploadImageList.length) < maxlength) {
          this.uploadImageList.push(file)
          if (this.uploadImageTimer) {
            clearTimeout(this.uploadImageTimer)
          }
          this.uploadImageTimer = setTimeout(() => {
            this.imgUploadHandle(arr, file, which, form)
          }, 100)
        } else {
          this.$message.error(this.$t('promptText.msg33') + ` ${maxlength}`)
          this.uploadImageList = []
        }
      } else {
        this.$message.error(this.$t('customDetail.onlyPictures'))
        this.uploadImageList = []
      }
      return false
    },
    imgUploadHandle(arr, file, which, form) {
      const that = this
      const imgFormData = new FormData()
      imgFormData.append('directory', 'customProduct/')
      imgFormData.append('signValue', that.imageSignValue)
      let alReadyCompressList = []
      this.imageLoading = true
      that.uploadImageList.map(e => alReadyCompressList.push(this.imageCompressorHandle(e)))
      Promise.all(alReadyCompressList).then(() => {
        alReadyCompressList.forEach(e => e.then(res => imgFormData.append('fileList', res)))
        API.customProductUploadFile(imgFormData).then(res => {
        // styleFormObj存放的key
          if (form.imageList) {
            form.imageList = form.imageList.concat(res.data.split(','))
          } else {
            arr = [...arr, ...res.data.split(',')]
          }
          let key = which === 'Style' ? 'imageUrl' : 'image'
          if (!form[key]) form[key] = res.data
          else form[key] = form[key] += `,${res.data}`
          this.uploadImageList = []
        }).finally(() => {
          this.imageLoading = false
        })
      })
    },
    // 图片压缩
    imageCompressorHandle(file) {
      let width = file.width
      let height = file.height
      if (file.width > 800) {
        width = 800
        height = file.width / file.height * 800
      }
      return new Promise((resolve, reject) => {
        new ImageCompressor({
          file,
          quality: 0.4, // 压缩质量
          width: width,
          height: height,
          mimeType: file.type === 'image/webp' ? 'image/jpeg' : 'auto',
          success(result) {
            resolve(result)
          }
        })
      })
    },
    imgVisit(imgUrl) {
      this.dialogImageUrl = imgUrl
      this.dialogVisible = true
    },
    imgUrlDelete(arr, index, obj) {
      arr.splice(index, 1)
      if (obj.imageUrl) {
        let arr = obj.imageUrl.split(',')
        arr.splice(index, 1)
        obj.imageUrl = arr.join(',')
      } else if (obj.image) {
        let arr = obj.image.split(',')
        arr.splice(index, 1)
        obj.image = arr.join(',')
      }
    },
    getAddParams() {
      let params = false
      this.$refs.styleFormObj.validate((valid) => {
        if (valid) {
          let styleFormObj = Object.assign({}, this.styleFormObj)
          styleFormObj.phoneNumber = `${styleFormObj.phoneAreaCode} ${styleFormObj.phoneNumber}`
          params = {
            ...styleFormObj,
            text: this.textFormObj,
            userId: this.$store.state.common.userId || undefined,
            userName: this.$store.state.common.userName || undefined
          }
          params.material = this.material.join(',')
          if (this.servicesSelect === 1) {
            params.type = 1
          } else {
            params.type = 2
            params.podStyle = this.printImageList.filter(e => e.check).map(e => e.value).join(',')
            if (!params.podStyle) {
              this.$message.error('Custom Printed& Embroidered Products Select at least one item')
              params = false
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
      return params
    },
    getAddParamsForMobile() {
      let params = false
      return params
    },
    async submit() {
      const params = this.getAddParams()
      if (!params) return
      const load = this.$loading.service()
      try {
        let res
        if (['add', 'visitorAdd'].includes(this.mode)) {
          res = await API.customProductAdd(params)
        } else if (this.mode === 'edit') {
          res = await API.customProductEdit(params)
        }
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$store.commit('commodity/set', { customProduct: null })
        const query = {
          email: this.styleFormObj.email,
          productName: this.styleFormObj.productName,
          DemandNo: res.data,
          addTime: dayjs().valueOf(),
          imageUrl: this.textFormObj.imageList[0]
        }
        this.$store.commit('commodity/set', { touristAddCustom: query })
        load.close()
        this.$router.push({
          path: '/customizedSuccess',
          query: {
            isList: this.mode === 'visitorAdd' ? 0 : 1
          }
        })
      } catch (error) {
        this.$message.error(error.data)
        load.close()
      }
    },
    numCheck(value, info) {
      const { target, key } = info
      let finalValue = value.replace(/[^\d.]/g, '')
      if (!finalValue) finalValue = undefined
      if (+finalValue === 0) finalValue = undefined
      target[key] = finalValue
    },
    floatCheck(e, info) {
      const { target, key, precision = 2 } = info
      let value = parseFloat(e.target.value)
      if (Number.isNaN(value)) {
        value = null
      } else {
        value = parseFloat(value.toFixed(precision))
      }
      target[key] = value
    },
    intCheck(e, info) {
      const { target, key } = info
      let value = parseInt(e.target.value)
      if (Number.isNaN(value)) {
        value = null
      }
      target[key] = value
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },

    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        this.dynamicTags.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    editTagClick(index) {
      this.editTagIndex = index
    },
    editTagBlur(value) {
      this.editTagIndex = null
    },
    async decisionMode() {
      if (this.$route.query.from === 'ai' && this.$store.state.commodity.customProduct && this.$store.state.commodity.customProduct.path === 'ai') {
        this.$set(this.textFormObj, 'imageList', this.$store.state.commodity.customProduct.imageList)
        this.$set(this.textFormObj, 'imageUrl', this.$store.state.commodity.customProduct.imageList.join())
      }
      if (this.$route.query.defaultPicture) {
        this.$set(this.textFormObj, 'imageList', [this.$route.query.defaultPicture])
        this.$set(this.textFormObj, 'imageUrl', this.$route.query.defaultPicture)
      }
      if (this.$route.query.defaultMaterial) {
        const defaultMaterials = this.$route.query.defaultMaterial.split(',').map(item => item.trim())
        const filteredOptions = this.materialSelectList.filter(option => defaultMaterials.includes(option.en))
        this.material = filteredOptions.map(option => option.value)
      }
      if (this.$route.query.defaultProductUrl) {
        this.textFormObj.referenceLinking = this.$route.query.defaultProductUrl
      }
      if (this.$route.path.includes('customizedAdd')) {
        this.mode = 'visitorAdd'
        this.servicesSelect = this.isPC ? 1 : undefined
        return
      }
      if (this.$route.path.includes('add')) {
        this.mode = 'add'
        this.servicesSelect = this.isPC ? 1 : undefined
      } else if (this.$route.path.includes('edit')) {
        this.mode = 'edit'
        let res = await API.customProductProductCustomDetail(this.$route.query.id)
        this.editDataHandle(res.data)
      } else if (this.$route.path.includes('detail')) {
        this.mode = 'read'
        let res = await API.customProductProductCustomDetail(this.$route.query.id)
        this.editDataHandle(res.data)
      }
    },
    editDataHandle(obj) {
      const { text, ...style } = obj
      const [phoneAreaCode, phoneNumber] = style.phoneNumber.split(' ')
      if (phoneNumber) {
        style.phoneAreaCode = phoneAreaCode
        style.phoneNumber = phoneNumber
      }
      Object.assign(this.styleFormObj, style)
      Object.assign(this.textFormObj, text, { imageList: text.imageUrl ? text.imageUrl.split(',') : [] })
      if (obj.material) this.material = obj.material.split(',')
      // 定制类型
      if (style.type === 1) {
        this.servicesSelect = 1
      } else {
        this.servicesSelect = 2
        style.podStyle.split(',').forEach(value => {
          let target = this.printImageList.find(e => +e.value === +value)
          target.check = true
        })
      }
    },
    printClick(value) {
      let index = this.printSelect.indexOf(value)
      if (index !== -1) {
        this.printSelect.splice(index, 1)
      } else {
        this.printSelect.push(value)
      }
    },
    printStyleClick(item) {
      if (this.mode === 'read') return
      item.check = !item.check
    }
  }
}
</script>

<style lang="scss" scoped>
[v-cloak] {
    display: none;
}
.customProductDetail {
    padding-top: 10px;
    min-height: 100%;
    padding-bottom: 100px;
    min-width: 1400px;
}
.formContent {
    margin: 20px 0;
    padding: 12px 0 12px 20px;
    /deep/.el-form-item__label {
        padding-bottom: 0px
    }
    .rightIcon {
        height: 20px;
        line-height: 20px;
        padding: 0 20px;
    }
    .formRequiredSign::after {
        content: '*';
        color: red;
        display: inline-block;
        position: relative;
        top: 3px;
        left: 4px;
    }
    .pictureCard {
        margin: 0 10px 10px 0;
        position: relative;
        width: 148px;
        height: 148px;
        border-radius: 6px;
        border: 1px solid #CDD4DD;
        cursor: pointer;
        >img {
            height: 100%;
            width: 100%;
            border-radius: 6px;
        }
        .deleteIcon {
            position: absolute;
            top: 0;
            right: 0;
            width: 30px;
            height: 30px;
            border-radius: 2px 6px 2px 30px;
            background: rgba(71, 71, 71, 0.6);
            transition: background .5s 0s;
            cursor: pointer;
        }
        .deleteIcon:hover {
            background: rgba(19, 18, 18, 0.6);
        }
        .el-icon-close {
            position: absolute;
            top: 6px;
            right: 6px;
            color: #fff;
            cursor: pointer;
            z-index: 10;
        }
        .el-icon-close:hover ~ .deleteIcon {
            background: rgba(19, 18, 18, 0.6);
        }
    }
    .addButton {
        text-align: center;
    }
    .top {
        padding-right: 20px;
        height: 30px;
        line-height: 30px;
        .title{
            font-weight: bold;
        }
    }
    /deep/.input-with-select .el-input-group__prepend {
        background-color: #fff;
        border-top-left-radius: 100px;
        border-bottom-left-radius: 100px;
    }
    .inputSelectGroup {
        >div:first-of-type {
            /deep/.el-input__inner {
                border-top-right-radius: 0 !important;
                border-bottom-right-radius: 0 !important;
            }
        }
        >div:nth-of-type(2) {
            /deep/.el-input__inner {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
            }
        }
    }
    .ServicesBox {
      >div{
        width: 500px;
        height: 140px;
        margin-right: 30px;
        border: 1px solid #CDD4DD;
        padding-left: 28px;
        position: relative;
        >img{
          width: 86px;
          height: 86px;
          margin-right: 20px;
        }
        >p{
          font-size: 18px;
          font-weight: 600;
        }
        .el-icon-success {
          color: #99C41C;
          font-size: 26px;
          position: absolute;
          right: 16px;
          top: 12px;
          display: none;
        }
        .iconActive{
          display: block !important;
        }
      }
      .serviceActive{
        border-color: #99C41C;
      }
    }
    .printImagesBox {
      width: 830px;
      .imageItem{
        width: 166px;
        height: 174px;
        border: 1px solid #CDD4DD;
        padding: 20px 8px;
        position: relative;
        /deep/.el-image{
          height: 100%;
        }
        .el-icon-success {
          color: #99C41C;
          font-size: 26px;
          position: absolute;
          right: 6px;
          top: 6px;
          display: none;
        }
        .iconActive{
          display: block !important;
        }
      }
      .printText {
        text-align: center;
        font-size: 14px;
      }
      .imageActive{
        border-color: #99C41C;
      }
      .smallSize {
        width:124px !important;
        height: 124px !important;
      }
    }
}
.boldLabel {
  font-weight: bold;
  font-size: 18px;
}
.bottomButton {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 80px;
    width: 100%;
    background: #fff;
    box-shadow: 0px -2px 12px 2px rgba(0, 0, 0, 0.06);
}

.customProductDetailForMobile {
  padding-bottom: 1.6rem;

  .breadcrumb {
    padding: .2rem .1rem;
    .el-icon-arrow-left {
      font-size: .3rem;
    }
    >span {
      font-size: .3rem;
    }
  }
  .formContentForMobile {
    margin-bottom: .2rem;
    .mobileInput {
      /deep/.el-input__inner {
        border-color: transparent !important;
        border-radius: 0;
        height: 1rem;
        line-height: 1rem;
      }
      /deep/.el-textarea__inner {
        border-color: transparent !important;
        border-radius: 0;
      }
    }
    .requiredInputMobile::after {
      display: block;
      content: '*';
      position: absolute;
      top: .2rem;
      left: 6px;
      color: red;
    }
    .mtOutLabel {
      font-weight: 600;
      font-size: .3rem;
      line-height: .8rem;
      position: relative;
    }
    .mtOutLabelRed::before{
      display: inline-block;
      content: '*';
      color: red;
      margin-right: .1rem;
      // position: absolute;
      // top: .1rem;
      // left: 0;
    }
  }
  .imageListBox {
    padding: .1rem;
    .uploadBox {
      width: 90px;
      height: 90px;
      /deep/.el-upload--picture-card {
        width: 100%;
        height: 100%;
        position: relative;
      }
      /deep/.el-icon-plus {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .pictureCard {
      position: relative;
      >img {
        width: 90px;
        height: 90px;
        padding: .1rem;
        border-radius: 6px;
      }
      .deleteIcon {
            position: absolute;
            top: 0;
            right: 0;
            width: 30px;
            height: 30px;
            border-radius: 2px 6px 2px 30px;
            background: rgba(71, 71, 71, 0.6);
            transition: background .5s 0s;
            cursor: pointer;
        }
        .deleteIcon:hover {
            background: rgba(19, 18, 18, 0.6);
        }
        .el-icon-close {
            position: absolute;
            top: 6px;
            right: 6px;
            color: #fff;
            cursor: pointer;
            z-index: 10;
        }
        .el-icon-close:hover ~ .deleteIcon {
            background: rgba(19, 18, 18, 0.6);
        }
    }
  }
  /deep/.el-form-item{
    margin-bottom: 0;
  }
  /deep/.el-form-item__error {
    position: static;
  }
}
  .materialMt {
    width: 100%;
    /deep/.el-input__inner{
      border-radius: 0px;
      border: none;
    }
  }
  .materialItem {
  padding: 8px 14px;
  background-color: #D9D9D947;
  border-radius: 30px;
  margin-right: 8px;
  line-height: 22px;
  margin-bottom: 10px;
}
.serviceBoxMT{
  border: 1px solid #CDD4DD;
  margin-bottom: 14px;
  padding: .2rem .3rem;
  >img{
    width: 60px;
    height:60px;
    margin-right: .2rem;
  }
  >p{
    font-size: .35rem;
  }
  .el-icon-success{
    color: #99C41C;
    font-size: .5rem;
    position: absolute;
    right: 16px;
    top: 12px;
    display: none;
  }
  .iconActive{
    display: block !important;
  }
}
.serviceActiveMt {
  border-color: #99C41C !important;
}
.printImageBoxMt {
  margin-bottom: 14px;
  >.imageBox{
    height: 78px;
    padding: 4px;
    border: 1px solid #CDD4DD;
  }

}
</style>
